module.exports = __webpack_public_path__ + "static/media/harvard.274a44ef.png";